import React, { useState } from "react";
import { TextField, MenuItem, Typography, TextFieldProps } from "@mui/material";

interface SelectFieldProps extends Omit<TextFieldProps, "select"> {
  name: string;
  label: string;
  options: string[];
  error?: boolean;
  helperText?: string;
  placeholder?: string;
  value?: string | number;
  required?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SelectField: React.FC<SelectFieldProps> = ({
  name,
  label,
  options,
  error = false,
  helperText = "",
  value,
  onChange,
  required = false,
  ...rest
}) => {
  const [active, setActive] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        width: "100%",
      }}
    >
      <Typography
        variant="body2"
        fontSize="clamp(12px, 0.8vw, 16px)"
        color="text.secondary"
        textAlign={"left"}
        sx={{ marginLeft: "4px" }}
      >
        {label}
        {required && <span style={{ color: "red", marginLeft: "2px" }}>*</span>}
      </Typography>
      <TextField
        name={name}
        select
        fullWidth
        value={value}
        onChange={onChange}
        error={error}
        helperText={helperText}
        onFocus={() => setActive(true)}
        onBlur={() => setActive(false)}
        InputProps={{
          onBlur: (e) => {
            setActive(false);
            if (rest.onBlur) {
              rest.onBlur(e);
            }
          },
          sx: {
            height: "clamp(35px, 4vh, 40px)",
            border: `1px solid ${
              active
                ? "#008AD8"
                : required && value === ""
                ? "orange"
                : "#AEBECD"
            }`,
            backgroundColor: "white",
            fontSize: "16px",
            borderRadius: "8px",
            "&:focus": {
              backgroundColor: "transparent",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&:focus .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            textAlign: "left",
          },
        }}
        {...rest}
      >
        {options.map((option) => (
          <MenuItem key={`select-${option}`} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
};

export default SelectField;
